const stats = {
  "CustomReportedRatio": {
    "Korea, South": 1,
    "Bahrain": 1,
    "Israel": 2.5,
    "US": 20,
    "United Kingdom": 30
  },
  "PopTotal": {
    "Afghanistan": 38041.757,
    "Albania": 2880.913,
    "Algeria": 43053.054,
    "Andorra": 77.146,
    "Angola": 31825.299,
    "Antigua and Barbuda": 97.115,
    "Argentina": 44780.675,
    "Armenia": 2957.728,
    "Australia": 25203.2,
    "Austria": 8955.108,
    "Azerbaijan": 10047.719,
    "Bahamas, The": 389.486,
    "Bahrain": 1641.164,
    "Bangladesh": 163046.173,
    "Barbados": 287.021,
    "Belarus": 9452.409,
    "Belgium": 11539.326,
    "Belize": 390.351,
    "Benin": 11801.151,
    "Bhutan": 763.094,
    "Bolivia": 11513.102,
    "Bosnia and Herzegovina": 3300.998,
    "Botswana": 2303.703,
    "Brazil": 211049.519,
    "Brunei Darussalam": 433.296,
    "Bulgaria": 7000.117,
    "Burkina Faso": 20321.383,
    "Burundi": 11530.577,
    "Cabo Verde": 549.936,
    "Cambodia": 16486.542,
    "Cameroon": 25876.387,
    "Canada": 37411.038,
    "CÃ´te d'Ivoire": 25716.554,
    "Central African Republic": 4745.179,
    "Chad": 15946.882,
    "Chile": 18952.035,
    "China": 1433783.692,
    "China (and dependencies)": 1465634.176,
    "China, Hong Kong SAR": 7436.157,
    "China, Macao SAR": 640.446,
    "Colombia": 50339.443,
    "China, Taiwan Province of China": 23773.881,
    "Comoros": 850.891,
    "Congo": 5380.504,
    "Costa Rica": 5047.561,
    "Croatia": 4130.299,
    "Cuba": 11333.484,
    "Cyprus": 1198.574,
    "Czechia": 10689.213,
    "Dem. People's Republic of Korea": 25666.158,
    "Democratic Republic of the Congo": 86790.568,
    "Denmark": 5771.877,
    "Djibouti": 973.557,
    "Dominica": 71.808,
    "Dominican Republic": 10738.957,
    "Ecuador": 17373.657,
    "Egypt": 100388.076,
    "El Salvador": 6453.55,
    "Equatorial Guinea": 1355.982,
    "Eritrea": 3497.117,
    "Estonia": 1325.649,
    "Eswatini": 1148.133,
    "Ethiopia": 112078.727,
    "Fiji": 889.955,
    "Finland": 5532.159,
    "France": 65129.731,
    "Gabon": 2172.578,
    "Gambia, The": 2347.696,
    "Georgia": 3996.762,
    "Germany": 83517.046,
    "Ghana": 30417.858,
    "Greece": 10473.452,
    "Grenada": 112.002,
    "Guatemala": 17581.476,
    "Guinea": 12771.246,
    "Guinea-Bissau": 1920.917,
    "Guyana": 782.775,
    "Haiti": 11263.079,
    "Holy See": 0.815,
    "Honduras": 9746.115,
    "Hungary": 9684.68,
    "Iceland": 339.037,
    "India": 1366417.756,
    "Indonesia": 270625.567,
    "Iraq": 39309.789,
    "Ireland": 4882.498,
    "Israel": 8519.373,
    "Italy": 60550.092,
    "Jamaica": 2948.277,
    "Japan": 126860.299,
    "Jordan": 10101.697,
    "Kazakhstan": 18551.428,
    "Kenya": 52573.967,
    "Kuwait": 4207.077,
    "Kyrgyzstan": 6415.851,
    "Latvia": 1906.74,
    "Lesotho": 2125.267,
    "Lebanon": 6855.709,
    "Libya": 6777.453,
    "Liberia": 4937.374,
    "Liechtenstein": 38.02,
    "Lithuania": 2759.631,
    "Luxembourg": 615.73,
    "Madagascar": 26969.306,
    "Malawi": 18628.749,
    "Malaysia": 31949.789,
    "Maldives": 530.957,
    "Mali": 19658.023,
    "Malta": 440.377,
    "Marshall Islands": 58.791,
    "Martinique": 375.557,
    "Mauritania": 4525.698,
    "Mauritius": 1269.67,
    "Mexico": 127575.529,
    "Micronesia": 543.483,
    "Monaco": 38.967,
    "Mongolia": 3225.166,
    "Montenegro": 627.988,
    "Morocco": 36471.766,
    "Mozambique": 30366.043,
    "Myanmar": 54045.422,
    "Namibia": 2494.524,
    "Nauru": 10.764,
    "Nepal": 28608.715,
    "Netherlands": 17097.123,
    "Netherlands (and dependencies)": 17435.228,
    "New Zealand": 4783.062,
    "New Zealand (and dependencies)": 4803.553,
    "Nicaragua": 6545.503,
    "Niger": 23310.719,
    "Nigeria": 200963.603,
    "North Macedonia": 2083.458,
    "Norway": 5378.859,
    "Oman": 4974.992,
    "Pakistan": 216565.317,
    "Palau": 18.001,
    "Panama": 4246.44,
    "Papua New Guinea": 8776.119,
    "Paraguay": 7044.639,
    "Peru": 32510.462,
    "Philippines": 108116.622,
    "Poland": 37887.771,
    "Portugal": 10226.178,
    "Puerto Rico": 2933.404,
    "Qatar": 2832.071,
    "Korea, South": 51225.321,
    "Romania": 19364.558,
    "Rwanda": 12626.938,
    "Russia": 145872.26,
    "Saint Kitts and Nevis": 52.834,
    "Saint Lucia": 182.795,
    "Saint Vincent and the Grenadines": 110.593,
    "San Marino": 33.864,
    "Saudi Arabia": 34268.529,
    "Senegal": 16296.362,
    "Serbia": 8772.228,
    "Seychelles": 97.741,
    "Singapore": 5804.343,
    "Slovakia": 5457.012,
    "Slovenia": 2078.654,
    "Somalia": 15442.906,
    "South Africa": 58558.267,
    "South Sudan": 11062.114,
    "Spain": 46736.782,
    "Sri Lanka": 21323.734,
    "Sudan": 42813.237,
    "Suriname": 581.363,
    "Sweden": 10036.391,
    "Switzerland": 8591.361,
    "Syrian Arab Republic": 17070.132,
    "Tajikistan": 9321.023,
    "Thailand": 69625.581,
    "Timor-Leste": 1293.12,
    "Togo": 8082.359,
    "Tonga": 104.497,
    "Trinidad and Tobago": 1394.969,
    "Tunisia": 11694.721,
    "Turkey": 83429.607,
    "Turkmenistan": 5942.094,
    "Tuvalu": 11.655,
    "Uganda": 44269.587,
    "Ukraine": 43993.643,
    "United Arab Emirates": 9770.526,
    "United Kingdom": 67530.161,
    "US": 329064.917,
    "Uruguay": 3461.731,
    "Uzbekistan": 32981.715,
    "Vanuatu": 299.882,
    "Venezuela (Bolivarian Republic of)": 28515.829,
    "Viet Nam": 96462.108,
    "Western Sahara": 582.458,
    "Yemen": 29161.922,
    "Zambia": 17861.034,
    "Zimbabwe": 14645.473
  }
}

export default stats